var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMobileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100.184
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3752",
    d: "M99.886 100.184H.118a.145.145 0 01-.088-.085.486.486 0 010-.328.145.145 0 01.089-.087h99.764a.145.145 0 01.089.087.348.348 0 01.028.166.34.34 0 01-.027.161.142.142 0 01-.087.086z",
    fill: "#de9c1d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3753",
    d: "M73.759 98.05l-7.471 1.464L20.326 3.768l3.738-2.41A8.352 8.352 0 0128.625 0h41.7a7.176 7.176 0 017.1 7.235v86.281a4.6 4.6 0 01-3.661 4.531z",
    fill: "rgba(151,20,77,0.11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3754",
    d: "M68.663 2.54H24.928c-3.08 0-5.578 2.2-5.578 4.9v87.2c0 2.7 2.5 4.9 5.578 4.9h43.735c3.08 0 5.578-2.2 5.578-4.9V7.412c.023-2.704-2.475-4.872-5.578-4.872zm4.027 91.825a3.793 3.793 0 01-4.015 3.526h-43.87a3.792 3.792 0 01-4.014-3.526V7.982c0-2.351 2.193-4.3 4.9-4.3h42.131c2.71 0 4.9 1.928 4.9 4.3z",
    fill: "#97144d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3755",
    d: "M46.633 3.459H25.474c-2.862 0-5.184 2.057-5.184 4.59v86.324c0 2.539 2.351 4.6 5.184 4.6h42.56c2.862 0 5.184-2.057 5.184-4.6V8.049c0-2.533-2.322-4.59-5.184-4.59z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3758",
    d: "M57.397 79.103h-21.33a4.185 4.185 0 00-4.185 4.185v.006a4.185 4.185 0 004.185 4.184h21.33a4.185 4.185 0 004.185-4.184v-.006a4.185 4.185 0 00-4.185-4.185z",
    fill: "#ffc555"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3776",
    d: "M49.714 3.285l-.265 1.017a3.4 3.4 0 01-6.471 0l-.265-1.017z",
    fill: "#97144d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3777",
    d: "M46.169 5.508a.988.988 0 111.07-.982 1.034 1.034 0 01-1.07.982zm0-1.516a.541.541 0 10.617.535.588.588 0 00-.617-.535z",
    fill: "#ffe3f1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4817",
    fill: "none",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4816"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3667",
    d: "M55.573 29.706a8.7 8.7 0 11-8.7-8.7 8.7 8.7 0 018.7 8.7z",
    stroke: "#b82b6e",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3668",
    d: "M51.116 26.494l-6.424 6.424-2.067-2.066",
    stroke: "#f27cb5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 500",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.959 48.853h35.595"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 501",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.959 55.853h6.59"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 502",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.959 55.853h25.59"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 503",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.959 61.853h25.59"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 504",
    stroke: "#858585",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M58.959 61.853h5.59"
  }))));
}
export default SvgCheckMobileIcon;